export const FONT_SIZES = [12, 14, 16, 18, 20, 22, 24, 28, 32];
export const FONT_SIZE_DEFAULT_INDEX = 2;

export const LINE_HEIGHTS = [
  { label: 'Default', value: '' },
  { label: '1.5', value: '1.5' },
  { label: '2.0', value: '2' },
  { label: '2.5', value: '2.5' },
  { label: '3.0', value: '3' },
];

export const LETTER_SPACINGS = [
  { label: 'Default', value: '' },
  { label: '0.05em', value: '0.05em' },
  { label: '0.1em', value: '0.1em' },
  { label: '0.15em', value: '0.15em' },
  { label: '0.2em', value: '0.2em' },
];

export const WORD_SPACINGS = [
  { label: 'Default', value: '' },
  { label: '0.1em', value: '0.1em' },
  { label: '0.2em', value: '0.2em' },
  { label: '0.4em', value: '0.4em' },
  { label: '0.6em', value: '0.6em' },
];

export const DEFAULT_SETTINGS = {
  fontSize: FONT_SIZE_DEFAULT_INDEX,
  lineHeight: 0,
  letterSpacing: 0,
  wordSpacing: 0,
  boldText: false,
  dyslexiaFont: false,
  darkContrast: false,
  lightContrast: false,
  highContrast: false,
  invertColors: false,
  monochrome: false,
  highSaturation: false,
  lowSaturation: false,
  highlightLinks: false,
  highlightHeadings: false,
  readingGuide: false,
  readingMask: false,
  focusMode: false,
  largeCursor: false,
  extraLargeCursor: false,
  stopAnimations: false,
  reduceTransitions: false,
  disableAutoplay: false,
  hideImages: false,
  keyboardNav: false,
  underlineLinks: false,
  protanopia: false,
  deuteranopia: false,
  tritanopia: false,
  language: 'en',
};

export const TRANSLATIONS = {
  en: {
    accessibility: 'Accessibility',
    close: 'Close',
    reset: 'Reset All',
    typography: 'Typography',
    fontSize: 'Font Size',
    increase: 'Increase',
    decrease: 'Decrease',
    resetFont: 'Reset',
    lineHeight: 'Line Height',
    letterSpacing: 'Letter Spacing',
    wordSpacing: 'Word Spacing',
    boldText: 'Bold Text',
    dyslexiaFont: 'Dyslexia Font',
    visual: 'Visual Adjustments',
    darkContrast: 'Dark Contrast',
    lightContrast: 'Light Contrast',
    highContrast: 'High Contrast',
    invertColors: 'Invert Colors',
    monochrome: 'Monochrome',
    highSaturation: 'High Saturation',
    lowSaturation: 'Low Saturation',
    navigation: 'Navigation',
    highlightLinks: 'Highlight Links',
    highlightHeadings: 'Highlight Headings',
    readingGuide: 'Reading Guide',
    readingMask: 'Reading Mask',
    focusMode: 'Focus Mode',
    cursor: 'Cursor',
    largeCursor: 'Large Cursor',
    extraLargeCursor: 'Extra Large Cursor',
    motion: 'Motion',
    stopAnimations: 'Stop Animations',
    reduceTransitions: 'Reduce Transitions',
    disableAutoplay: 'Disable Autoplay',
    language: 'Language',
    english: 'English',
    nepali: 'नेपाली',
    on: 'On',
    off: 'Off',
    panelTitle: 'Accessibility Settings',
    toggleButton: 'Toggle accessibility panel',
    skipToContent: 'Skip to main content',
    hideImages: 'Hide Images',
    keyboardNav: 'Keyboard Nav',
    underlineLinks: 'Underline Links',
    colorBlind: 'Color Blindness',
    protanopia: 'Protanopia',
    deuteranopia: 'Deuteranopia',
    tritanopia: 'Tritanopia',
  },
  ne: {
    accessibility: 'पहुँच',
    close: 'बन्द गर्नुहोस्',
    reset: 'सबै रिसेट गर्नुहोस्',
    typography: 'टाइपोग्राफी',
    fontSize: 'फन्ट साइज',
    increase: 'बढाउनुहोस्',
    decrease: 'घटाउनुहोस्',
    resetFont: 'रिसेट',
    lineHeight: 'लाइन हाइट',
    letterSpacing: 'अक्षर स्पेसिङ',
    wordSpacing: 'शब्द स्पेसिङ',
    boldText: 'बोल्ड टेक्स्ट',
    dyslexiaFont: 'डिस्लेक्सिया फन्ट',
    visual: 'दृश्य समायोजन',
    darkContrast: 'गाढा कन्ट्रास्ट',
    lightContrast: 'हल्का कन्ट्रास्ट',
    highContrast: 'उच्च कन्ट्रास्ट',
    invertColors: 'रङ्ग उल्टाउनुहोस्',
    monochrome: 'मोनोक्रोम',
    highSaturation: 'उच्च संतृप्ति',
    lowSaturation: 'कम संतृप्ति',
    navigation: 'नेभिगेसन',
    highlightLinks: 'लिङ्क हाइलाइट',
    highlightHeadings: 'शीर्षक हाइलाइट',
    readingGuide: 'पढ्ने गाइड',
    readingMask: 'पढ्ने मास्क',
    focusMode: 'फोकस मोड',
    cursor: 'कर्सर',
    largeCursor: 'ठूलो कर्सर',
    extraLargeCursor: 'अतिरिक्त ठूलो कर्सर',
    motion: 'गति',
    stopAnimations: 'एनिमेसन रोक्नुहोस्',
    reduceTransitions: 'ट्रान्जिसन घटाउनुहोस्',
    disableAutoplay: 'अटोप्ले बन्द गर्नुहोस्',
    language: 'भाषा',
    english: 'English',
    nepali: 'नेपाली',
    on: 'खुला',
    off: 'बन्द',
    panelTitle: 'पहुँच सेटिङहरू',
    toggleButton: 'पहुँच प्यानल खोल्नुहोस्',
    skipToContent: 'मुख्य सामग्रीमा जानुहोस्',
    hideImages: 'तस्वीर लुकाउनुहोस्',
    keyboardNav: 'किबोर्ड नेभिगेसन',
    underlineLinks: 'लिङ्क रेखांकित',
    colorBlind: 'रङ्ग अन्धोपन',
    protanopia: 'प्रोटानोपिया',
    deuteranopia: 'ड्युटेरानोपिया',
    tritanopia: 'ट्राइटानोपिया',
  },
};
